import { STATISTICS_PRESETS, type StatisticsPreset } from './statisticsParams'

/** Legacy `app-v3-statistics-parameters`: one dropdown offering the 4 fixed
 * resolution/days combinations, prefixed "Chart settings:". */
export function StatisticsParametersPicker({
  preset,
  onChange,
}: {
  preset: StatisticsPreset
  onChange: (preset: StatisticsPreset) => void
}) {
  const value = `${preset.resolution}:${preset.days}`
  return (
    <label className="portal-inline-actions">
      <span>Chart settings:</span>
      <select
        aria-label="Chart settings"
        value={value}
        onChange={(event) => {
          const found = STATISTICS_PRESETS.find((p) => `${p.resolution}:${p.days}` === event.target.value)
          if (found) onChange(found)
        }}
      >
        {STATISTICS_PRESETS.map((p) => (
          <option key={`${p.resolution}:${p.days}`} value={`${p.resolution}:${p.days}`}>
            {p.label}
          </option>
        ))}
      </select>
    </label>
  )
}
